import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
} from "@mui/material";

const NewVersionPopup = ({
  open,
  onRefresh,
  onCancel,
  isCancelDisabled,
}: any) => {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>New Version Available</DialogTitle>
      <DialogContent>
        A new version of this application is available. Refresh to get the
        latest updates.
      </DialogContent>
      <Alert color="warning">
        Warning: Refreshing will cause losing you current data
      </Alert>
      <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          onClick={onCancel}
          disabled={isCancelDisabled}
          data-tracker="392"
        >
          Remind Me in 1 Hour
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={onRefresh}
          data-tracker="393"
        >
          Refresh
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewVersionPopup;
